import React from 'react';
import { companyActions } from '../../redux/actions/company-action';
import { userActions } from '../../redux/actions/user-actions';
import { connect } from 'react-redux';
import CompanyForm from './Company/CompanyForm';
import {
  Grid,
  Row,
  Col,
  Button
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import InputMask from 'react-input-mask';

class CompanyProfilePage extends React.Component {
	constructor(props){
		super(props);


		this.state = {
			id : this.props.userAdmin.user.id,
			companyId : this.props.userAdmin.user.company_id,
			contact :{},
			formType:'edit',
			adminType : this.props.adminType,
			user:{ name:'', email: '', password:'', phone:'', permission:0 },
			userError : {
		        nameError:'',
		        emailError:'',
		        passwordError:'',
		        phoneError:''
		    },
		    submitted: false
		};
		this.handleAction = this.handleAction.bind(this);
		this.handleUser = this.handleUser.bind(this);
		this.handleUserEditSubmit = this.handleUserEditSubmit.bind(this);
		this.handleActionEditCompany = this.handleActionEditCompany.bind(this);
	};

	handleActionEditCompany(companyData){
		this.props.editCompanyCall(this.state.companyId, companyData);
	}
	
	handleUserEditSubmit(e){
	    e.preventDefault();
	    this.setState({ submitted: true }, function(){
	      const err = this.validate();
	      if (!err){
	      	this.props.editCompanyUserCall(this.state.user, this.state.id);
	        //const { dispatch } = this.props;
	        //dispatch(companyActions.editCompanyUser(this.state.user, this.state.companayId, this.state.id));
	      }
	    });
	}
	validate(){
	    let   isError = false;
	    const errors = {
	      nameError:'',
	      emailError:'',
	      passwordError:'',
	      phoneError:''
	    };

	    if (this.state.user.name.length === 0 || this.state.user.name.trim() === '') {
	        isError = true;
	        errors.nameError = "Name is required.";
	    }

	    if (this.state.user.email.length === 0 || !(this.state.user.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) ) {
	        isError = true;
	        errors.emailError = "Email is required & must be abc@example.com format.";
	    }

	    

	    
	    if ((this.state.user.phone.length === 0) || !(this.state.user.phone.match(/^((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/g)) ) {
	        isError = true;
	        errors.phoneError = "Phone is required & format must be 123-456-7890.";
	    }


	    this.setState({userError: errors}, function(){

	    });
	    return isError; 
	}
	handleUser(e){
	    const { name, value } = e.target;
	    const userState = {...this.state.user};
	    userState[name] = value;
	    this.setState({user: userState}, function(){

	    });
	}
	handleAction(festivalData){
		this.props.editFestivalCall(this.state.festivalId, festivalData);
	};
	componentDidMount () {
		this.props.getCompanyUserCall(this.state.id);
		this.props.getCompanyProfileInfoCall(this.state.companyId);
	    //this.props.getFestivalCall(this.state.festivalId);
  	}

  	componentWillReceiveProps(nextProps) {

      if (nextProps.editUser && !nextProps.loading){
        this.setState({user:{
          name:nextProps.editUser.name,
          email:nextProps.editUser.email,
          password:'',
          phone: nextProps.editUser.phone,
          permission: nextProps.editUser.permission
        }}, function(){

          this.setState({addModalUserEdit:true});
        });
      }
      
  	}

	render(){
		const { companyInfo } = this.props;
		const { userError, submitted } = this.state;
		return(
			<div className="content">
	        	<Grid fluid>
	          		<Row>
	            		<Col md={12}>
	              			<Card
				                title="Company User Profile"
				                content={
				                	<div>
			                            <Grid fluid>
			                                <Row>
			                                	<div className="row">
					                                <div className="col-md-12">
					                                    <form onSubmit={this.handleUserEditSubmit}>
					                                      <div className="row">
					                                        <div className="col-md-6">
					                                          <div className={'form-group' + (submitted && userError.nameError!=='' ? ' has-error' : '')}>
					                                            <label htmlFor="name">Name</label>
					                                            <input type="text" name="name" className="form-control"  value={this.state.user.name} onChange={this.handleUser}/>
					                                            {
					                                              submitted && userError.nameError!=='' &&
					                                              <div className="help-block">{userError.nameError}</div>
					                                            }
					                                          </div>
					                                        </div>
					                                        <div className="col-md-6">
					                                          <div className={'form-group' + (submitted && userError.emailError!=='' ? ' has-error' : '')}>
					                                            <label htmlFor="email">Email</label>
					                                            <input type="text" name="email" className="form-control" value={this.state.user.email} onChange={this.handleUser} readOnly/>
					                                            {
					                                              submitted && userError.emailError!=='' &&
					                                              <div className="help-block">{userError.emailError}</div>
					                                            }
					                                          </div>
					                                        </div>
					                                      </div>
					                                      <div className="row">
					                                        <div className="col-md-6">
					                                          <div className={'form-group' + (submitted && userError.phoneError!=='' ? ' has-error' : '')}>
					                                            <label htmlFor="Phone">Phone</label>
					                                            <InputMask  mask="999-999-9999" maskChar={null} type="text" name="phone" className="form-control" placeholder="123-456-7890" value={this.state.user.phone}  onChange={this.handleUser} />
					                                            {
					                                              submitted && userError.phoneError!=='' &&
					                                              <div className="help-block">{userError.phoneError}</div>
					                                            }
					                                          </div>
					                                        </div>
					                                        <div className="col-md-6">
					                                          <div className={'form-group' + (submitted && userError.passwordError!=='' ? ' has-error' : '')}>
					                                            <label htmlFor="password">Password</label>
					                                            <input type="password" name="password" className="form-control" value={this.state.user.password}  onChange={this.handleUser} minLength="6" />
					                                            {
					                                              submitted && userError.passwordError!=='' &&
					                                              <div className="help-block">{userError.passwordError}</div>
					                                            }
					                                          </div>
					                                        </div>
					                                      </div>
					                                      <div className="row">
					                                        <div className="col-md-12">
					                                          <div className='form-group'>
					                                            <Button type='submit' bsSize="large" bsStyle="info" className="outOfTableButton pull-right" >Save</Button>
					                                          </div>
					                                        </div>
					                                      </div>


					                                    </form>
					                                </div>
					                            </div>
			                                </Row>
			                            </Grid>
			                        </div>
				                }
				            />
	             		</Col>
	            	</Row>

	            	<Row>
	            		<Col md={12}>
	              			<Card
				                title="Company Information"
				                content={
				                	<div>
			                            <Grid fluid>
			                                <Row>
			                                	<Col md={12}>
			                                		{
														companyInfo && this.state.contact && <CompanyForm handleActionParent={this.handleActionEditCompany}  companyDataFP={companyInfo} companyContactDataFP = {companyInfo.contact} formType={this.state.formType} adminType="company" />
													}
			                                	</Col>
			                                </Row>
			                            </Grid>
			                        </div>
				                }
				            />
	             		</Col>
	            	</Row>
	          	</Grid>
	        </div>
			
		);
	};
}

const mapDispatchToProps = dispatch => {
  return ({
    getCompanyUserCall : (id) => { dispatch(userActions.getUser(id)) },
    editCompanyUserCall : (userData, companyUserId) => { dispatch(userActions.editUser(userData, companyUserId)) },
  	getCompanyProfileInfoCall  : (id) => { dispatch(companyActions.getCompanyProfileInfo(id)) },
  	editCompanyCall : (id,companyData) => { dispatch(companyActions.editCompany(id, companyData)) }
  });
};

function mapStateToProps(state) {
    const { loading, companyInfo } = state.companyReducer;
    const { editUser } = state.userReducer;
    const { adminType, userAdmin } = state.adminReducer;
    return {
        loading, adminType, userAdmin, companyInfo, editUser
    };
}

const CompanyProfile = connect(mapStateToProps, mapDispatchToProps)(CompanyProfilePage);
export default CompanyProfile;


// WEBPACK FOOTER //
// ./src/components/Admin/CompanyProfile.jsx